import { Box, Grid, Typography } from "@mui/material";
import logo from "../../assets/images/Logo.png";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { GoLightBulb } from "react-icons/go";
import { RxHamburgerMenu } from "react-icons/rx";
import { useState } from "react";
import Fade from "react-reveal/Fade";
import { FaUser } from "react-icons/fa6";

const ActiveJobs = ({ title, progress, color }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Box>
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>

        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "20px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About Us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact Us
            </b>
          </a>
          <Box className={styles.login_btn} sx={{ marginLeft: "10px" }}>
            <a onClick={() => navigate("/login")}>
              Login{" "}
              <FaUser
                style={{ color: "#fff", fontSize: "14px", marginLeft: "5px" }}
              />
            </a>
          </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px  ",
                  fontWeight: "500",
                }}
              >
                Home
              </b>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </b>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                About Us
              </b>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Contact Us
              </b>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                Login{" "}
                <FaUser
                  style={{ color: "#fff", fontSize: "14px", marginLeft: "5px" }}
                />
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "20px" }} id="home" />

      <Box className={styles.home_structure}>
        <Fade bottom delay={200}>
          <Box className={styles.active_jobs}>
            <Typography sx={{ fontSize: "20px !important", margin: "20px" }}>
              <b>Currently Active jobs</b>
            </Typography>

            <Grid container sx={{ alignSelf: "end", width: "100%" }}>
              <Grid
                item
                xs={12}
                sm={6}
                md={5}
                lg={5}
                sx={{ padding: "0 10px 0 10px" }}
              >
                <Box className={styles.contract_Requirements}>
                  <Typography sx={{ fontSize: "16px !important" }}>
                    <b>Contract Job Requirements</b>
                  </Typography>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <b style={{ fontSize: "16px" }}>No of Post 270</b>

                    <Typography
                      sx={{ fontSize: "25px !important", color: "#00b04f" }}
                    >
                      <b>77%</b>
                    </Typography>
                  </span>
                  <hr style={{ marginTop: "0" }}></hr>
                </Box>
                <Box className={styles.contract_Requirements}>
                  <Typography sx={{ fontSize: "16px !important" }}>
                    <b>Full Time Job Requirements</b>
                  </Typography>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <b style={{ fontSize: "16px" }}>No of Post 270</b>

                    <Typography
                      sx={{ fontSize: "25px !important", color: "#7030a1" }}
                    >
                      <b>15%</b>
                    </Typography>
                  </span>
                  <hr style={{ marginTop: "0" }}></hr>
                </Box>
                <Box className={styles.contract_Requirements}>
                  <Typography sx={{ fontSize: "16px !important" }}>
                    <b>W2 Job Openings</b>
                  </Typography>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <b style={{ fontSize: "16px" }}>No of Post 270</b>

                    <Typography
                      sx={{ fontSize: "25px !important", color: "#ffbf00" }}
                    >
                      <b>08%</b>
                    </Typography>
                  </span>
                  <hr style={{ marginTop: "0" }}></hr>
                </Box>
                <Typography
                  sx={{
                    fontSize: "20px !important",
                    margin: "12px",
                    marginTop: "60px",
                  }}
                >
                  <b>AI Analytical Report.</b>
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px !important",
                    margin: "10px",
                    "@media (max-width: 600px)": {
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  More than 70% job requirement not in proper format
                  <span className="mobile-remove-br">
                    <br />
                  </span>
                  so not much more response on jobs
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={7}
                lg={7}
                sx={{
                  padding: {
                    xs: "0 5px 0 5px",
                    sm: "0 10px 0 10px",
                  },
                }}
              >
                <Box className={styles.apply_Requirements}>
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>Full Stack Java Developer at Pennsylvania, PA</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 57 Mins
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 12 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Master Card </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $70/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>
                <Box className={styles.duration_Requirements}>
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>PHP Developer Laravel at Dallas Taxes, TX</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 2 Hours
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 06 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Capital One </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $50/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>
                <Box className={styles.client_Requirements}>
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>SQL Developer at Dallas Taxes, TX</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 1 Day
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 12 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Master Card </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $40/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>
                <Box className={styles.apply_Requirements}>
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>Full Stack Java Developer at Pennsylvania, PA</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 57 Mins
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 12 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Master Card </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $70/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>
                <Box className={styles.duration_Requirements}>
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>PHP Developer Laravel at Dallas Taxes, TX</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 2 Hours
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 06 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Capital One </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $50/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>
                <Box className={styles.client_Requirements}>
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>SQL Developer at Dallas Taxes, TX</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 1 Day
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 12 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Master Card </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $40/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>
                <Box className={styles.apply_Requirements}>
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>Full Stack Java Developer at Pennsylvania, PA</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 57 Mins
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 12 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Master Card </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $70/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>
                <Box className={styles.duration_Requirements}>
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>PHP Developer Laravel at Dallas Taxes, TX</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 2 Hours
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      fontSize: "17px !important",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 06 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Capital One </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $50/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>
                <Box className={styles.client_Requirements}>
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>SQL Developer at Dallas Taxes, TX</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 1 Day
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      fontSize: "17px !important",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 12 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Master Card </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $40/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>
                <Box
                  className={styles.apply_Requirements}
                  sx={{ marginBottom: "20px" }}
                >
                  <span
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      <b>Full Stack Java Developer at Pennsylvania, PA</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13.5px !important",
                          sm: "16px !important",
                        },
                      }}
                    >
                      Since 57 Mins
                    </Typography>
                  </span>
                  <span
                    style={{
                      color: "#757172",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        <b>Duration: 12 Months on C2C </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Client: Master Card </b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "13.5px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        {" "}
                        <b>Rate: $70/hourly </b>
                      </Typography>
                    </span>
                    <Typography
                      sx={{
                        fontSize: "25px !important",
                        color: "#ffbf00",
                        alignSelf: "end",
                      }}
                    >
                      <button onClick={() => navigate("/login")}>
                        Apply Now
                      </button>
                    </Typography>
                  </span>
                </Box>

                <button className={styles.view_btns}>Next</button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
        <Box>
          <Footer />
        </Box>
      </Box>
      <Fade />
    </Box>
  );
};

export default ActiveJobs;
